import React from 'react';
import { NT_COLORS } from './NotionUI';
import { useLanguage } from '../i18n/LanguageContext';
import Select from './Select';

const COLOR_NAMES = Object.keys(NT_COLORS);

/**
 * Elenco modificabile delle opzioni di una colonna selezione/stato:
 * nome, colore e (solo per lo stato) "completata". Le opzioni già salvate
 * mantengono il loro `value`, così le attività che le usano restano valide.
 */
function ColumnOptionsEditor({ options, onChange, withDone }) {
  const { t } = useLanguage();

  const patch = (index, change) => onChange(options.map((o, i) => (i === index ? { ...o, ...change } : o)));

  return (
    <div className="pd-options">
      {options.map((option, index) => (
        <div key={option.value || `new-${index}`} className="pd-option-row">
          <Select
            className="dd-color"
            swatch
            value={option.color || 'grey'}
            aria-label={t('projectDetail.optionColor')}
            onChange={(e) => patch(index, { color: e.target.value })}
          >
            {COLOR_NAMES.map((name) => (
              <option key={name} value={name} data-color={NT_COLORS[name]}>{t(`projectDetail.color_${name}`)}</option>
            ))}
          </Select>
          <input
            value={option.label}
            maxLength={60}
            placeholder={t('projectDetail.optionName')}
            aria-label={t('projectDetail.optionName')}
            onChange={(e) => patch(index, { label: e.target.value })}
          />
          {withDone && (
            <label className="pd-option-done" title={t('projectDetail.optionDoneHint')}>
              <input type="checkbox" checked={Boolean(option.done)} onChange={(e) => patch(index, { done: e.target.checked })} />
              {t('projectDetail.optionDone')}
            </label>
          )}
          <button
            type="button"
            className="pd-row-delete pd-option-remove"
            aria-label={t('projectDetail.removeOption')}
            disabled={options.length <= 1}
            onClick={() => onChange(options.filter((_, i) => i !== index))}
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        className="nt-ghost-btn"
        onClick={() => onChange([...options, { label: '', color: 'grey' }])}
      >
        + {t('projectDetail.addOption')}
      </button>
    </div>
  );
}

export default ColumnOptionsEditor;
